import React, { Dispatch } from 'react';

import { InfoTableHeaderCell } from './info-table-header-cell';
import { IInfoTableColumn, IInfoTableColumnSorting } from 'types/info-table';

import styles from './styles.module.css';

interface IInfoTableHeaderProps<T> {
  columns: IInfoTableColumn<T>[];
  columnsSorting?: IInfoTableColumnSorting[];
  sortColumnData?: Dispatch<IInfoTableColumnSorting>;
}

export const InfoTableHeader = <T,>(props: IInfoTableHeaderProps<T>) => {
  const { columns, columnsSorting, sortColumnData } = props;

  return (
    <div className={styles.header}>
      {columns.map((column) => (
        <InfoTableHeaderCell
          key={column.accessorKey}
          column={column}
          columnsSorting={columnsSorting}
          sortColumnData={sortColumnData}
        />
      ))}
    </div>
  );
};
